import React from 'react'
import clsx from 'clsx'
import CuestionarioForm from '../components/Cuestionario/Index'

export default function Cuestionario() {
  return (
    <div>
      <CuestionarioForm />
    </div>
  )
}
